module.exports = __webpack_public_path__ + "img/twitter-white.22b14969.png";